import { version } from "react";

import { getCacheHitRatio } from "@atlaskit/react-ufo/additional-payload";
import { AdditionalData } from "@atlaskit/react-ufo/config";
import type { InteractionMetrics } from "@atlaskit/react-ufo/interaction-metrics";

export function getCustomData(interaction: InteractionMetrics) {
    let customData: AdditionalData = {};
    const nextHopProtocol = performance
        .getEntriesByType("resource")
        // @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
        .find(({ nextHopProtocol }) => !!nextHopProtocol);
    // @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    customData.httpProtocol = nextHopProtocol?.nextHopProtocol ?? "unknown";

    const { start } = interaction;

    if (interaction.type === "page_load") {
        customData = {
            ...customData,
            ...getCacheHitRatio({ start }),
            "app:framework:name": "react",
            "app:framework:version": version
        };
    }
    return customData;
}
